const initUser = {
  code: "",
  first_name: "",
  last_name: "",
  password: '',
  email: "",
}

export default initUser
